import { DeleteModal } from "./DeleteModal";
import { AddModal } from "./AddModal";

export const Modal = {
  DeleteModal,
  AddModal,
};
